import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import intlTelInput from 'intl-tel-input';
import { UserService } from '../user-management/service/userservice';
import validationform from '../../../../validation/validationform';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrl: './new-user.component.scss'
})
export class NewUserComponent {

   initContry:any;
   submitted:boolean=false;
   spinner:boolean=false;
   countryCode2:any;
   countryCode1:any;
   roleList:any[]=[];
newUserForm:FormGroup=new FormGroup({});
@Output() cancel:EventEmitter<any> = new EventEmitter();
  @ViewChild('intlInput') intlInput!: ElementRef;
constructor(private fb:FormBuilder,private userService:UserService,private route:Router,private messageService: MessageService){}

ngOnInit(){


   this.newUserForm = this.fb.group({
      company_name: [''],
      location: [''],
      username: ['', Validators.required],
      first_name: [''],
      last_name: [''],
      middle_name:[''],
      email: ['', [Validators.required, Validators.email]],
      userid:[''],
      role: ['', Validators.required],
      doj:[''],
      empid:[''],
      phone_number: [
        '',
        [Validators.required, Validators.pattern('[- +()0-9]+.{9,}')],
      ],
      password: ['']
    });
     this.getUserRoles();
  }



   getUserRoles(){
      this.userService.getuserRoleList().subscribe((res:any)=>{
        this.roleList = res;
      });
  }


   onSubmit() {
    this.submitted = true;
    
    // if(this.newUserForm.controls['email'].value=="" && this.newUserForm.controls['userid'].value==""){
    //   this.newUserForm.controls['email'].setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]{2,}$')]);
    //   this.newUserForm.controls['email'].updateValueAndValidity();
    //   this.newUserForm.controls['userid'].setValidators([Validators.required]);
    //   this.newUserForm.controls['userid'].updateValueAndValidity();
    // }
    // else if(this.newUserForm.controls['email'].invalid && this.newUserForm.controls['userid'].value==""){
    //   this.newUserForm.controls['userid'].setValidators([Validators.required]);
    //   this.newUserForm.controls['userid'].updateValueAndValidity();
    // } 
    // else{
    //   this.newUserForm.controls['email'].clearValidators();
    //   this.newUserForm.controls['email'].updateValueAndValidity();
    //   this.newUserForm.controls['userid'].clearValidators();
    //   this.newUserForm.controls['userid'].updateValueAndValidity();
    // }
    if (this.newUserForm.valid) {
      this.spinner = true;
      const value = this.newUserForm.controls['phone_number'].value;
       this.countryCode2 = this.initContry.getSelectedCountryData().dialCode;
      if (!value.includes('+91')) {
        this.newUserForm.controls['phone_number'].setValue(
          '+' +
            (this.countryCode2
              ? this.countryCode2
              : this.countryCode1
            ).toString() +
            this.newUserForm.controls['phone_number'].value
        );
      }
      
      this.userService.addUser(this.newUserForm.value).subscribe(
        (sub) => {
          this.newUserForm.reset();
         // this.addNewUser.emit(this.addUserData);
        
          this.spinner = false;
          this.submitted = false;
        },
        (errors:HttpErrorResponse) => {
          console.log('new user error', errors.error.message);
           this.messageService.add({ severity: 'info', summary: 'Info', detail:errors.error.message, life: 3000 });
          this.spinner = false;
         
        }
      );
    } else {
      validationform.ValidateAllFormFields(this.newUserForm);
    }
  }



    goSettings() {
    
  }
  get f(): { [key: string]: AbstractControl } {
    return this.newUserForm.controls;
  }

  pressCancel() {
    this.cancel.emit();
     this.route.navigateByUrl("main/contracts/userManagement");
  }



   ngAfterViewInit(){
        this.initContry = intlTelInput(this.intlInput.nativeElement, {
        allowDropdown: true,
        nationalMode: true,
        initialCountry: 'in',
        separateDialCode: false
      });
  }

}
